import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { Paciente } from '../../pacientes/pacientes';
import { PacienteService } from '../../../core/services/pacientes.service';
import { DatosRecetaPDF, RecetasPdf } from '../../../core/services/recetas-pdf.service';
import { AuthService } from '../../../core/services/auth.service';
import { Receta, RecetasService } from '../../../core/services/recetas.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-resumen-receta-dialog',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, DatePipe],
  templateUrl: './resumen-receta-dialog.html',
  styleUrl: './resumen-receta-dialog.scss',
})
export class ResumenRecetaDialog implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ResumenRecetaDialog>,
    @Inject(MAT_DIALOG_DATA) public paciente: Paciente,
    private recetaService: RecetasService,
    private recetaPdf: RecetasPdf,
    private authService: AuthService,
  ) {}

  recetas: Receta[] = [];
  cargando = false;

  ngOnInit(): void {
    this.cargarReceta();
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  cargarReceta(): void {
    if (!this.paciente.id) {
      // console.warn('El paciente no tiene ID');
      return;
    }

    this.cargando = true;

    this.recetaService.obtenerRecetasPorPaciente(this.paciente.id).subscribe({
      next: (recetas: Receta[]) => {
        this.recetas = [...(recetas ?? [])].sort(
          (a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime(),
        );

        this.cargando = false;
      },

      error: (error) => {
        // console.error('Error al obtener recetas del paciente:', error);

        this.recetas = [];
        this.cargando = false;
      },
    });
  }

  obtenerFecha(fecha: string): string {
    if (!fecha) return '';

    const fechaDate = new Date(fecha);

    if (isNaN(fechaDate.getTime())) return '';

    return fechaDate.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'America/Mexico_City',
    });
  }

  async regenerarPDF(receta: Receta): Promise<void> {
    try {
      const guardada = receta as any;

      if (!this.paciente?.id) {
        throw new Error('No se encontró la información del paciente.');
      }

      const estudiosTexto = (guardada.estudios ?? [])
        .map((estudio: any) => {
          const nombre = estudio.nombre ?? 'Estudio sin nombre';
          const indicaciones = estudio.indicaciones?.trim();

          return indicaciones ? `• ${nombre}\n  ${indicaciones}` : `• ${nombre}`;
        })
        .join('\n');

      const datosPDF: DatosRecetaPDF = {
        paciente: this.paciente,
        signosVitales: null,
        medico: guardada.medico ?? null,
        medicamentos: guardada.medicamentos ?? [],
        folio: guardada.folio ?? null,
        numeroExpediente: this.paciente.numeroExpedienteMedico ?? null,

        receta: {
          diagnostico: guardada.impresion ?? guardada.diagnostico ?? guardada.padecimiento ?? '',
          indicaciones: guardada.indicaciones ?? '',
          observaciones: guardada.observaciones ?? '',
          estudios: estudiosTexto,
          proximaCita: guardada.proximaCita ?? '',
          motivoProximaCita: guardada.motivoProximaCita ?? '',
          metas: guardada.metas ?? '',
          objetivos: guardada.objetivos ?? '',
        },
      };

      await this.recetaPdf.generarReceta(datosPDF);
    } catch (error) {
      console.error('Error al volver a generar la receta:', error);

      await Swal.fire({
        icon: 'error',
        title: 'No se pudo mostrar el PDF',
        text: 'Ocurrió un error al generar nuevamente la receta.',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
}
